import React, { FC } from 'react'
import classNames from 'classnames'
import { Icon, IconButton } from '@mui/material'
import { Forward5Sharp } from '@mui/icons-material'

import styles from './Button.module.scss'

interface Props {
  onClick: () => void
}

export const FastforwardButton: FC<Props> = ({ onClick }) => (
  <IconButton
    aria-label="forward"
    className={styles.OverlayButton}
    onClick={onClick}
  >
    <Icon
      component={Forward5Sharp}
      className={classNames(styles.OverlayIcon, styles.MediumOverlayIcon)}
    />
  </IconButton>
)
